import {Component, attr} from "../Component";
import {element} from "../CustomElement";
import {inject} from "../../services/di";
import {LinkService} from "../../services/LinkService";
import {LocationService} from "../../services/LocationService";
import {HistoryService} from "../../services/HistoryService";
import {AggregateSourceAction} from "../../services/definitions/IAnalyticsService";

interface LinkProps extends JSX.HTMLProps {
	to?: any;
	params?: { [name: string]: any };
	href?: string;
	back?: boolean;
	sourceAction?: AggregateSourceAction;
}

@element("flipp-link", "a")
export class Link extends Component<LinkProps, any> {
	@attr back: boolean;
	@attr href: string;
	@attr sourceAction: AggregateSourceAction;
	@inject location: LocationService;
	@inject historyService: HistoryService;

	set to(obj: any) {
		this._to = obj;
	}

	set params(params: any) {
		this._params = params;
	}

	private _to: any = null;
	private _params: { [name: string]: any } = null;

	onAttach() {
		this.addEventListener("click", this._handleClick);
	}

	onDetach() {
		this.removeEventListener("click", this._handleClick);
	}

	render() {
		return <template><content /></template>;
	}

	onRender() {
		let href: string = LinkService.getInstance().linkTo(this._to, this._params);

		if (href) {
			this.href = href;
		}

		// check if currently active
		if (location.pathname === ((this as any) as HTMLAnchorElement).pathname) {
			this.setAttribute("active", "");
		} else {
			this.removeAttribute("active");
		}
	}

	private _handleClick = (e: Event) => {
		if (e.defaultPrevented) return;
		e.preventDefault();

		if (this.back) {
			this.historyService.doBack();
		} else {
			LinkService.getInstance().execute(this.href, this, { sourceAction: this.sourceAction });
		}
	}
}

// --- flipp-button-link ------------------------------------------------->

/* An alternative implementation of the Link component using a Button. This is
	* because the Link component is tied closely to the router and it's not appropriate
	* in all contexts. For example, showing an ecom/coupon item on the search page should just open
	* the ecom/coupon item pop, not also execute a page transition */
@element("flipp-button-link", "button")
export class ButtonLink extends Component<any, any> {

	set onclick(handler: JSX.GenericEventHandler) {
		this.addEventListener("click", handler);
	}

	render() {
		return <template>
			<content />
		</template>;
	}
}
